(() => {
  const cache = new Map();
  const endpoint = 'https://diggnitcustomersupport.floot.app/_api/reviews/storefront/summary';

  const fetchSummary = (proof) => {
    const { lpProductId, lpProductHandle, lpLocale } = proof.dataset;
    if (!lpProductId || !lpProductHandle) return Promise.resolve(null);
    const url = new URL(endpoint);
    url.searchParams.set('productId', lpProductId);
    url.searchParams.set('productHandle', lpProductHandle);
    url.searchParams.set('locale', lpLocale || 'en');
    const key = url.toString();
    if (!cache.has(key)) {
      cache.set(key, fetch(key).then((response) => {
        if (!response.ok) throw new Error('Review summary unavailable');
        return response.json();
      }).then((response) => {
        const value = response && response.json && typeof response.json === 'object' ? response.json : response;
        const count = Number(value?.reviewCount);
        const score = Number(value?.avgRating);
        if (!Number.isSafeInteger(count) || count <= 0 || !Number.isFinite(score) || score < 1 || score > 5) return null;
        return { count, score };
      }).catch(() => null));
    }
    return cache.get(key);
  };

  const initialize = () => {
    document.querySelectorAll('[data-lp-rating]').forEach((proof) => {
      fetchSummary(proof).then((summary) => {
        if (!summary) return;
        const score = proof.querySelector('[data-lp-rating-score]');
        const count = proof.querySelector('[data-lp-rating-count]');
        if (!score || !count) return;
        score.textContent = summary.score.toFixed(1);
        count.textContent = (proof.dataset.lpReviewCountTemplate || '__count__').replace('__count__', String(summary.count));
        proof.hidden = false;
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
